import { request } from '@/request/request';
import { parameterChange } from '@/utils';

export default {
  // 类别列表
  orderPageList(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/order/orderPageList?${parameterChange(data)}`,
      method: 'get',
      data,
    });
  },
};
